import {AxiosError} from 'axios';
import {PaginatedData} from 'web-library/models/List';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {ExamSubjects} from '../../api/candidate/exam/model';
import {SearchUniqueLinkSubjectsRequest} from '../../pages/uniqueLink/AdminUniqueLink/model';
import {POST_UNIQUE_LINK_SUBJECTS_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<ExamSubjects>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSearchUniqueLinkSubjects = ({onSuccess, onError}: Input = {}) => {
  const postSearchUniqueLinkSubjects = async (payload: SearchUniqueLinkSubjectsRequest) => {
    const res = await axiosClient.post<PaginatedData<ExamSubjects>>(
        POST_UNIQUE_LINK_SUBJECTS_URL(payload.apiPathParam),
        payload.reqBody
    );
    return res.data;
  };

  return useCustomMutation(postSearchUniqueLinkSubjects, {
    onSuccess,
    onError,
  });
};
